import gql from "graphql-tag";

export const ORDER_SUM_QUERY = gql`
  query OrderSumItemsQuery(
    $startEpoch: Float!
    $endEpoch: Float!
    $timeStep: SumSteps!
  ) {
    ordersSumItems(
      where: { in_timeSpan: { startEpoch: $startEpoch, endEpoch: $endEpoch } }
      sum: $timeStep
    ) {
      count
      result {
        title
        quantity
        timeLine {
          timeStamp
          total
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/queries/OrdersSumQuery/queries.ts